import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({

  root: {
    backgroundColor: '#f9fbfd',
    height: '100%',
    overflowY: 'auto',
    padding: '2vw',
    fontSize: 18,
    flexDirection: 'column',
    paddingBottom: 20,
  },
}))

export default styles
